import { AppState } from "../../reducers";
import { ToastState } from "./toastSlice";

export const toastSelector = (state: AppState): ToastState => {
  return state.toast;
};
